var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 14.5C15.25 14.9142 15.5858 15.25 16 15.25C16.4142 15.25 16.75 14.9142 16.75 14.5H15.25ZM2 6.13639L1.45452 5.62166L0.968805 6.13639L1.45452 6.65112L2 6.13639ZM2 6.9045H11.5789V5.4045H2V6.9045ZM15.25 10.8397V14.5H16.75V10.8397H15.25ZM11.5789 6.9045C13.566 6.9045 15.25 8.62475 15.25 10.8397H16.75C16.75 7.87952 14.4753 5.4045 11.5789 5.4045V6.9045ZM5.82952 0.985269L1.45452 5.62166L2.54548 6.65112L6.92048 2.01473L5.82952 0.985269ZM1.45452 6.65112L5.82952 11.2875L6.92048 10.258L2.54548 5.62166L1.45452 6.65112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoMedium);
export default __webpack_public_path__ + "static/media/undo-medium.793d89056c5f52c9c46b82b9edd7ee49.svg";
export { ForwardRef as ReactComponent };